import { WrapperAmplitudeCompanyTab } from "components/company/v3/WrapperCompany";
import BrazilianEventsBox from "components/company/v3/brazilian/boxes/BrazilianEventsBox";
import BrazilianPageLayout from "components/company/v3/layouts/BrazilianPageLayout";
import { CompanyEventsTabEnum } from "components/company/v3/menu/enums";
import BrazilianIssuerSeo from "components/company/v3/seo/BrazilianIssuerSeo";
import { EventsCalendarFilterRange } from "components/investorrelations/enums";
import useEventsCalendarState from "components/investorrelations/hooks/useEventsCalendarState";
import IssuerHeaderByTickerSymbol from "components/issuers/IssuerHeaderByTickerSymbol";
import useSelfie from "lib/hooks/useSelfie";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import { parseAsStringEnum, useQueryState } from "nuqs";
import NotFound from "pages/404";
import { useIntl } from "react-intl";
import { ISecurityCountry } from "types/graphqlTypes";

interface BrazilianEventsPageProps {
  tickerSymbol: string | null;
}

const BrazilianEventsPage: NextPage<BrazilianEventsPageProps> = function BrazilianEventsPage({ tickerSymbol }) {
  const intl = useIntl();
  const [tab, setTab] = useQueryState(
    "tab",
    parseAsStringEnum<CompanyEventsTabEnum>(Object.values(CompanyEventsTabEnum)).withDefault(
      CompanyEventsTabEnum.CALENDAR,
    ),
  );

  const filterState = useEventsCalendarState({ period: EventsCalendarFilterRange.InTheYear });
  const viewer = useSelfie();
  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();

  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <BrazilianPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyTab category="Ações" tab={tab} tickerSymbol={normalizedTickerSymbol}>
        <>
          <BrazilianIssuerSeo
            tickerSymbol={normalizedTickerSymbol}
            title={intl.formatMessage({
              defaultMessage: "Dividendos",
              id: "CXcewN",
              description: "Título da página - SEO",
            })}
          />

          {!viewer && (
            <IssuerHeaderByTickerSymbol
              country={ISecurityCountry.Br}
              tickerSymbol={normalizedTickerSymbol}
              className="pb-6"
              title={intl.formatMessage({ defaultMessage: "Dividendos", id: "A7Fc1J" })}
              description={intl.formatMessage({
                defaultMessage:
                  "Confira abaixo a tabela completa e atualizada com todo histórico de dividendos pagos, declarados, etc",
                id: "xBVNop",
              })}
            />
          )}

          <BrazilianEventsBox
            // key={format("events/%s/%s", tickerSymbol, tab)}
            tickerSymbol={normalizedTickerSymbol}
            tab={tab}
            onChangeTab={setTab}
            {...filterState}
          />
        </>
      </WrapperAmplitudeCompanyTab>
    </BrazilianPageLayout>
  );
};

BrazilianEventsPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default BrazilianEventsPage;
